import { render } from "./Kpi.vue?vue&type=template&id=66472373&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"

import "./Kpi.vue?vue&type=style&index=0&id=66472373&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66472373"]])

export default __exports__